import { MetadataContent } from '@jutro/legacy/uiconfig';
import { appendMetadataWithIndex } from 'ml-portals-util-react';

import metadata from './VehicleDriversComponent.metadata.json5';
import styles from './VehicleDriversComponent.module.scss';

import React from 'react';

const VehicleDriversComponent = (props) => {
    const {
        model: vehicleDrivers,
        vehicleIndex,
        drivers,
        updateTotalPercentage,
        refreshData,
        isPolicyChange
    } = props;

    const getDriverNameById = (id) => {
        const driver = drivers.find((el) => el.fixedId === id);
        return driver ? driver.person.getFullName() : '';
    };

    const getDriverNameByIdPolicyChange = (id) => {
        const driver = drivers.find((el) => el.fixedId === id);
        return driver.person.displayName;
    };

    const generateOverrides = () => {
        const overrides = vehicleDrivers.map((vehicleDriver, index) => {
            return {
                [`vehicleDriverLabelContainer${vehicleIndex}${index}`]: {
                    className: isPolicyChange ? 'col-md-2' : 'col-md-2 padding-top-15'
                },
                [`vehicleDriverLabel${vehicleIndex}${index}`]: {
                    content: isPolicyChange ? getDriverNameByIdPolicyChange(vehicleDriver.driverID.value) : getDriverNameById(vehicleDriver.driverID.value)
                },
                [`vehicleDriverInputContainer${vehicleIndex}${index}`]: {
                    className: isPolicyChange ? 'col-md-5' : 'col-md-4'
                },
                [`vehicleDriverInput${vehicleIndex}${index}`]: {
                    className: isPolicyChange ? 'col-md-5' : 'col-md-4'
                },
                [`vehicleDriverInput${vehicleIndex}${index}`]: {
                    value: vehicleDriver.percentageDriven_Ext.value,
                    onValueChange: (value) => {
                        vehicleDriver.percentageDriven_Ext.value = value;
                        updateTotalPercentage(vehicleDriver.vehicleID.value);
                        refreshData();
                    }
                },
            };
        });
        return Object.assign({}, ...overrides);
    };

    const overrides = {
        [`vehicleDriversIterable${vehicleIndex}`]: {
            data: vehicleDrivers
        },
        ...generateOverrides()
    };

    const resolvers = {
        resolveClassNameMap: styles
    };

    const updatedMetadata = appendMetadataWithIndex(metadata.componentContent, vehicleIndex);
    return <MetadataContent uiProps={updatedMetadata} overrideProps={overrides} {...resolvers} />;
};

VehicleDriversComponent.defaultProps = {
    isPolicyChange: false
};

export default VehicleDriversComponent;
